import {connect} from 'react-redux';
import AddLocationDialog from '../../components/dialogs/AddLocationDialog';
import {cancel, changeValue, save} from "../../actions/addLocationAction";

const mapStateToProps = state => {
    return {
        addLocation: state.addLocation
    }
};

const mapDispatchToProps = dispatch => {
    return {
        cancel: () => {
            dispatch(cancel())
        },
        changeValue: (name, value) => {
            dispatch(changeValue(name, value))
        },
        save: (data) => {
            dispatch(save(data))
        }
    }
};

const AddLocationDialogContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AddLocationDialog);

export default AddLocationDialogContainer;